var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimSuggestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.01579C4 7.59474 4.14737 7.23684 4.44211 6.9421C4.73685 6.64737 5.09474 6.5 5.51579 6.5L14.5684 6.5C14.7649 6.5 14.958 6.53874 15.1478 6.61621C15.337 6.69312 15.5018 6.80175 15.6421 6.94211L19.5579 10.8579C19.6982 10.9982 19.8072 11.1633 19.8846 11.3531C19.9615 11.5422 20 11.7351 20 11.9316L20 17.6158C20 18.0368 19.8526 18.3947 19.5579 18.6895C19.2632 18.9842 18.9053 19.1316 18.4842 19.1316L5.51579 19.1316C5.09474 19.1316 4.73684 18.9842 4.44211 18.6895C4.14737 18.3947 4 18.0368 4 17.6158L4 8.01579ZM5.26316 8.01579L5.26316 17.6158C5.26316 17.6719 5.29123 17.7281 5.34737 17.7842C5.40351 17.8403 5.45965 17.8684 5.51579 17.8684L18.4842 17.8684C18.5404 17.8684 18.5965 17.8403 18.6526 17.7842C18.7088 17.7281 18.7368 17.6719 18.7368 17.6158L18.7368 11.8474L14.6526 7.76316L5.51579 7.76316C5.45965 7.76316 5.40351 7.79123 5.34737 7.84737C5.29123 7.90351 5.26316 7.95965 5.26316 8.01579ZM5.26316 8.01579L5.26316 7.76316L5.26316 17.8684L5.26316 17.6158L5.26316 8.01579Z",
    fill: "#292B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimSuggestion);
export default __webpack_public_path__ + "static/media/SimSuggestion.69bd70cc2911d7ca9ba5dcef4bed2892.svg";
export { ForwardRef as ReactComponent };